import React from "react";
import CategoryItemMain from "../../Components/CategoryItems/CategoryItemMain";

const Category = () => {
  
  return (
    <div>
        <CategoryItemMain />
    </div>
  );
};

export default Category;